<template>
  <div class="kpi-card">
    <div class="kpi-left">
      <div class="kpi-label">{{ label }}</div>
      <div class="kpi-value">{{ value }}</div>
      <div v-if="hint" class="kpi-hint"><slot name="hint" /></div>
    </div>
    <div class="kpi-icon">
      <slot name="icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: "KpiCard",
  props: {
    label: { type: String, required: true },
    value: { type: String, required: true },
    hint: { type: String, default: "" },
  },
};
</script>

<style scoped>
.kpi-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-radius: 10px;
  padding: 16px 20px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  min-height: 110px;
  transition: all 0.2s ease;
}
.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}
.kpi-left {
  display: flex;
  flex-direction: column;
}
.kpi-label {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 4px;
}
.kpi-value {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}
.kpi-hint {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}
.kpi-icon {
  font-size: 24px;
  color: var(--kpi-icon-color, #6b7280);
}
</style>
